<template>
    <table class="table table-responsive-xl table-bordered footable" v-if="items.length > 0">
        <tbody>
            <tr>
                <td width="70">
                    {{this.cur_item.name}}
                </td>
                
                <td v-for="item in items" :class="get_item_class(item)" v-on:click.stop.prevent="on_change(item)">
                    {{item.time}}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "conference_type",
    props : {
        cur_item : {
            type : Object,
        }
    },
    
    methods: {
        on_change(item) {
            this.$emit('change',item,this.cur_item.type);
        },
        
        get_item_class(item) {
            let base_class = item.class;
            if(item.hasOwnProperty("is_selected")) {
                if(item.is_selected) {
                    base_class = base_class + " selected"
                }
            }
            
            return base_class;
        }
        
    },
    
    computed: {
        items () {
            if(this.obj_to_null(this.cur_item)) {
                if(this.cur_item.hasOwnProperty("items")) {
                    return this.cur_item.items;
                }
            }
            return [];
        }
        
    }
}
</script>


<style scoped>

</style>